module.exports = __webpack_public_path__ + "static/electrician-working-12a555bd022f93c66e80b6b431a5c7dc.png";